/**
 * tvPermissionAssignment Module
 *
 * Description 电视权限分配
 * Author:SMG 2019-4-23
 */
'use strict';
angular.module('tvPermissionAssignment', ['manageCfg.roleManageMent.permissionAssignment.SavePerModule']).controller('tvPermissionAssignmentCtrl', [
    '$scope',
    '$timeout',
    'trsColumnTreeLocationService',
    '$state',
    '$modal',
    '$compile',
    '$element',
    '$q',
    'localStorageService',
    'trsHttpService',
    'modalDialog',
    'permissionAssignmentService',
    function(
        $scope,
        $timeout,
        trsColumnTreeLocationService,
        $state,
        $modal,
        $compile,
        $element,
        $q,
        localStorageService,
        trsHttpService,
        modalDialog,
        permissionAssignmentService
    ) {
        // 声明将要保存权限的数组对象开始
        var selecetedChanls = {};
        // 声明将要保存权限的数组对象结束
        initStatus();
        initData();
        $scope.productAndModule = function() {
            var productAndModule = $modal.open({
                templateUrl: './manageConfig/roleManageMent/permissionAssignment/service/productAndModule/productAndModule_tpl.html',
                scope: $scope,
                windowClass: 'manage-authorityAssignment',
                backdrop: false,
                controller: 'productAndModuleCtrl',
            });
        };
        $scope.channelTreeOptions = {
            nodeChildren: 'CHILDREN',
            injectClasses: {
                ul: 'a1',
                li: 'manage-main-rightDiv-leftDiv-treeLi',
                liSelected: 'a7',
                iExpanded: 'a3', // "manage-main-rightDiv-leftDiv-treeIcon",
                iCollapsed: 'a4', // "manage-main-rightDiv-leftDiv-treeIcon",
                iLeaf: 'a5',
                label: 'a6',
                labelSelected: 'a8',
            },
            isLeaf: function(node) {
                return node.HASCHILDREN === 'false';
            },
            dirSelectable: true,
            allowDeselect: false,
        };
        // 展开树操作
        $scope.showToggle = function(node) {
            if (angular.isDefined(node.CHILDREN) && node.HASCHILDREN === 'true' && node.CHILDREN.length === 0) {
                $scope.getChildrenNodes(node, function(CHILDREN) {
                    node.CHILDREN = CHILDREN;
                });
            }
        };

        /**
         * [getChildrenNodes description] 获取子栏目方法
         * @param  {[type]} node    [description]
         * @param  {[type]} success [description]
         * @return {[type]}         [description]
         */
        $scope.getChildrenNodes = function(node, success) {
            var params = {
                serviceid: 'mlf_website',
                methodname: 'queryChildChannels',
                ChannelId: node.CHANNELID,
                RoleId: $scope.roleData.ROLEID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                success(data.CHILDREN);
            });
        };

        /**
         * [isAuthorized description]判断是否已赋权，渲染左侧树节点
         * @return boolean [description]
         */
        $scope.isAuthorized = function(node) {
            var flag = false;
            if (angular.isDefined(node.RIGHTINDEX)) {
                var rightIndexs = node.RIGHTINDEX.split(',');
                for (var i = 0; i < rightIndexs.length; i++) {
                    if (node.RIGHTVALUE[parseInt(rightIndexs[i].replace(/\"/g, '')) - 1] === '1') {
                        flag = true;
                    }
                }
            }
            return flag;
        };
        $scope.cTshowSelected = function(sel) {
            permissionAssignmentService.initGroupRight(sel, $scope.roleData.ROLEID).then(function(data) {
                sel.RIGHTID = data; // data;
                delete $scope.rightClassify;
                $scope.authorSelectedNode = sel;
                if (!angular.isArray($scope.authorSelectedNode.RIGHTVALUE)) {
                    $scope.authorSelectedNode.RIGHTVALUE = $scope.authorSelectedNode.RIGHTVALUE.split('');
                    $scope.authorSelectedNode.HASSED = $scope.authorSelectedNode.RIGHTVALUE.indexOf('1') > -1;
                }
                // 将要推送的保存权限对象开始
                var tempId = $scope.authorSelectedNode.OBJID;
                var tempObj = {
                    ID: parseInt($scope.authorSelectedNode.RIGHTID),
                    OPRTYPE: 203,
                    OPRID: parseInt($scope.roleData.ROLEID),
                    OBJTYPE: parseInt($scope.authorSelectedNode.OBJTYPE),
                    OBJID: parseInt($scope.authorSelectedNode.OBJID),
                    NEWVALUE: $scope.authorSelectedNode.RIGHTVALUE,
                };
                selecetedChanls[tempId] = tempObj;
                // 将要推送的保存权限对象结束
                queryRightClassify($scope.classify, sel);
                updateBatPermissionAssignment();
            });
        };
        // 批量授权开始
        $scope.batPermissionAssignment = function(node) {
            if (angular.isUndefined($scope.perSelectedNode.CHANNELID)) {
                modalDialog.alertType('站点不允许批量授权', '', 'warning', false);
                return;
            }
            if (angular.isUndefined($scope.rightClassify)) {
                modalDialog.alertType('请先选择要授权的节点', '', 'warning', false);
                return;
            }
            if (angular.isDefined($scope.batSetChanls[node.OBJID])) {
                delete $scope.batSetChanls[node.OBJID];
                return;
            }
            $scope.batSetChanls[$scope.authorSelectedNode.OBJID] = {
                ID: parseInt($scope.authorSelectedNode.RIGHTID),
                OPRTYPE: 203,
                OPRID: parseInt($scope.roleData.ROLEID),
                OBJTYPE: parseInt($scope.authorSelectedNode.OBJTYPE),
                OBJID: parseInt($scope.authorSelectedNode.OBJID),
                NEWVALUE: $scope.authorSelectedNode.RIGHTVALUE,
            };
            permissionAssignmentService.initGroupRight(node, $scope.roleData.ROLEID).then(function(data) {
                $scope.batSetObj = {
                    ID: parseInt(data),
                    OPRTYPE: 203,
                    OPRID: parseInt($scope.roleData.ROLEID),
                    OBJTYPE: parseInt(node.OBJTYPE),
                    OBJID: parseInt(node.OBJID),
                    NEWVALUE: $scope.authorSelectedNode.RIGHTVALUE,
                };
                updateBatPermissionAssignment();
                $scope.batSetChanls[node.OBJID] = $scope.batSetObj;
            });
        };
        // 批量授权结束
        // 监控授权操作给批量对象赋值
        $scope.$watch('authorSelectedNode.RIGHTVALUE', function(newValue, oldValue) {
            updateBatPermissionAssignment();
        });
        // 监控授权操作给批量对象赋值
        // 更新批量授权开始
        function updateBatPermissionAssignment() {
            for (var i in $scope.batSetChanls) {
                $scope.batSetChanls[i].NEWVALUE = $scope.authorSelectedNode.RIGHTVALUE;
            }
        }
        // 更新批量授权结束
        // 处理节点名称，用于应对不同模块类型节点名称显示
        $scope.getNodeDesc = function(node) {
            // angular.element('span.assignedAuthority').each(function(){//用于给父级添加class改变样式
            //     angular.element(this).parent('div.tree-label').addClass('assignedAuthority');
            // });
            return angular.isDefined(node.MODALDESC) ? node.MODALDESC : angular.isDefined(node.SITEDESC) ? node.SITEDESC : node.CHNLDESC;
        };
        $scope.SavePermissions = function() {
            var savePermissions = $modal.open({
                templateUrl: './manageConfig/roleManageMent/permissionAssignment/service/SavePerModule/SavePerModule.html',
                scope: $scope,
                windowClass: 'manageSavePerTemp',
                backdrop: false,
                controller: 'SavePerModuleController',
            });
        };
        // 判断节点是否是根节点
        // 参数1：节点 类型：obj
        // 返回值：true(是根节点) false:（false）
        $scope.isRootNode = function(node) {
            return !!angular.isUndefined(node.CHANNELID);
        };
        // 保存权限开始
        $scope.save = function() {
            commonSave();
        };
        // 普通保存权限
        function commonSave() {
            var i = 0,
                postRights = [];
            concatPermission();
            for (var key in selecetedChanls) {
                postRights.push(angular.copy(selecetedChanls[key]));
                postRights[i].NEWVALUE = angular.isArray(postRights[i].NEWVALUE) ? postRights[i].NEWVALUE.join('') : postRights[i].NEWVALUE;
                i++;
            }
            var postRightsString = JSON.stringify(postRights);
            var params = {
                serviceid: 'mlf_extrole',
                methodname: 'saveRight',
                RoleId: $scope.roleData.ROLEID,
                IsSynchronize: 'false',
                rights: postRightsString,
            };
            if (postRights.length === 0) {
                modalDialog.alertType('您尚未设置权限', '您尚未设置权限', 'error', false);
                return;
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('保存权限成功', '', 'success', false);
                $scope.batSetChanls = {};
                delete $scope.authorSelectedNode;
                delete $scope.rightClassify;
                getChannelTree($scope.siteId, $scope.roleData.ROLEID);
            });
        }
        // 递归保存权限
        function toChildrenSave() {
            if (angular.isUndefined($scope.perSelectedNode.CHANNELID)) {
                modalDialog.alertType('站点不能对子节点进行权限传递', '', 'warning', false);
                return;
            }
            var params = {
                serviceid: 'mlf_extrole',
                methodname: 'saveRight',
                RoleId: $scope.roleData.ROLEID,
                IsSynchronize: 'true',
                rights: JSON.stringify([
                    {
                        ID: parseInt($scope.perSelectedNode.RIGHTID),
                        OPRTYPE: 203,
                        OPRID: parseInt($scope.roleData.ROLEID),
                        OBJTYPE: parseInt($scope.perSelectedNode.OBJTYPE),
                        OBJID: parseInt($scope.perSelectedNode.OBJID),
                        NEWVALUE: angular.isArray($scope.perSelectedNode.RIGHTVALUE)
                            ? $scope.perSelectedNode.RIGHTVALUE.join('')
                            : $scope.perSelectedNode.RIGHTVALUE,
                    },
                ]),
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('保存权限成功', '', 'success', false);
                $scope.batSetChanls = {};
                delete $scope.authorSelectedNode;
                delete $scope.rightClassify;
                getChannelTree($scope.siteId, $scope.roleData.ROLEID);
            });
        }
        // 合并批量授权和普通授权开始
        function concatPermission() {
            for (var i in $scope.batSetChanls) {
                selecetedChanls[i] = $scope.batSetChanls[i];
            }
        }
        // 合并批量授权和普通授权结束
        // 保存权限结束
        // 获取树开始
        function getChannelTree(siteId, roleId, callback) {
            var params = {
                serviceid: 'mlf_website',
                methodname: 'queryChannelTree',
                SiteId: siteId,
                RoleId: roleId,
            };
            $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'get').then(function(data) {
                if (angular.isFunction(callback)) {
                    callback(data);
                } else {
                    $scope.channelTree = data;
                    treeLocation().then(function() {
                        $scope.cTshowSelected($scope.perSelectedNode);
                    });
                }
            });
        }

        /**
         * [treeLocation description] 树节点自动定位
         * @return {[type]} [description]
         */
        function treeLocation() {
            $scope.expandedNodes = [];
            $scope.expandedNodes.push($scope.channelTree[0]);
            var deffer = $q.defer();
            if (!$scope.perSelectedNode || !$scope.perSelectedNode.CHANNELID) {
                // 初始进入时或选中节点本身就为站点时，默认选中根节点，也就是站点节点
                $scope.perSelectedNode = $scope.channelTree[0];
                $scope.expandedNodes = [$scope.channelTree[0]];
                deffer.resolve();
            } else {
                // 当选中节点为栏目时，执行这种操作
                trsColumnTreeLocationService.columnTreeLocation(
                    1,
                    $scope.perSelectedNode.CHANNELID,
                    $scope.channelTree[0],
                    $scope.perSelectedNode,
                    $scope.expandedNodes,
                    function(tree, array, selectedNode) {
                        delete $scope.channelTree;
                        $scope.channelTree = [tree];
                        $scope.perSelectedNode = selectedNode;
                        deffer.resolve();
                    },
                    $scope.getChildrenNodes
                );
            }
            return deffer.promise;
        }
        // 获取树结束
        // 获取权限列表开始
        function queryRightClassify(classify, node) {
            var params = {
                serviceid: 'mlf_extrole',
                methodname: 'queryRightClassify',
                Classify: classify,
            };
            if (!angular.isDefined(node.CHANNELID)) {
                params.Classify = 'tvsite';
            }
            $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'get').then(function(data) {
                if ($scope.authorSelectedNode !== undefined) {
                    $scope.rightClassify = data;
                    // 初始化全选按钮开始
                    $scope.initSelectAll();
                    // 初始化全选按钮结束
                }
            });
        }
        // 获取权限列表结束
        // 初始化全选按钮方法开始
        $scope.initSelectAll = function() {
            $scope.rightClassify.selectAll = true;
            for (var i = 0; i < $scope.rightClassify.CHILDREN.length; i++) {
                $scope.rightClassify.CHILDREN[i].selectAll = true;
                for (var j = 0; j < $scope.rightClassify.CHILDREN[i].CHILDREN.length; j++) {
                    if (
                        $scope.authorSelectedNode.RIGHTVALUE.length === 0 ||
                        $scope.authorSelectedNode.RIGHTVALUE[$scope.rightClassify.CHILDREN[i].CHILDREN[j].RIGHTINDEX - 1] == '0'
                    ) {
                        $scope.rightClassify.CHILDREN[i].selectAll = false;
                    }
                }
                if ($scope.rightClassify.CHILDREN[i].selectAll === false) {
                    $scope.rightClassify.selectAll = false;
                }
            }
        };
        // 初始化全选按钮方法结束
        /**
         * [selectTemplateFn description] 选择模板
         * @return {[type]} [description]
         */
        $scope.selectTemplateFn = function(index) {
            $timeout(function() {
                if (!angular.isArray($scope.selectTemplate.NEWVALUE) && $scope.selectTemplate.NEWVALUE !== undefined) {
                    $scope.authorSelectedNode.RIGHTVALUE = $scope.selectTemplate.NEWVALUE.split('');
                    $scope.authorSelectedNode.HASSED = $scope.authorSelectedNode.RIGHTVALUE.indexOf('1') > -1;
                    var tempObj = {
                        ID: parseInt($scope.authorSelectedNode.RIGHTID),
                        OPRTYPE: 203,
                        OPRID: parseInt($scope.roleData.ROLEID),
                        OBJTYPE: parseInt($scope.authorSelectedNode.OBJTYPE),
                        OBJID: parseInt($scope.authorSelectedNode.OBJID),
                        NEWVALUE: $scope.authorSelectedNode.RIGHTVALUE,
                    };
                    selecetedChanls[$scope.authorSelectedNode.OBJID] = tempObj;
                    // 全选按钮初始化开始
                    $scope.initSelectAll();
                    // 全选按钮初始化结束
                }
            });
        };

        function initData() {
            // 获取从产品列表得到的产品数据开始
            getProductListData();
            // 获取从产品列表得到的产品数据结束
            if ($scope.roleData === undefined) {
                modalDialog.alertType('请先选择角色', '', 'info', false);
                $state.go('manageconfig.rolemanage');
            }
            // 监控左边选择角色是否变动
            $scope.$on('roleData', function(event, roleData) {
                $scope.roleData = roleData;
                selecetedChanls = {};
                $scope.batSetChanls = {};
                getChannelTree($scope.siteId, $scope.roleData.ROLEID);
                delete $scope.rightClassify;
            });
            // 批量设置权限对象初始化开始
            $scope.batSetChanls = {};
            // 批量设置权限对象初始化结束
            $scope.batSetObj = {};
        }

        // 获取从产品列表得到产品数据开始
        function getProductListData() {
            var productListData = localStorageService.get('setEditingCenterPermission');
            $scope.siteDesc = productListData.siteDesc;
            $scope.moduleName = productListData.moduleName;
            $scope.mediaType = productListData.mediaType;
            $scope.siteId = productListData.siteId;
            $scope.classify = productListData.CLASSIFY;
            delete $scope.rightClassify;
            selecetedChanls = {};
            getChannelTree($scope.siteId, $scope.roleData.ROLEID);
            $scope.isPaper = true;
        }
        // 获取从产品列表得到产品数据结束
        // 取消选择树节点开始
        function cancelSelectedNode() {
            delete $scope.perSelectedNode;
        }
        // 取消选择树节点结束
        // 初始化状态
        function initStatus() {
            $scope.status = {};
        }
        // 批量授权单选框是否选中判断方法
        $scope.batPerAssCheckboxSelected = function(node) {
            return !!angular.isDefined($scope.batSetChanls[node.OBJID]);
        };
    },
]);
